import YoungPersonLegalDetailsForm from './YoungPersonLegalDetails';
export default YoungPersonLegalDetailsForm;
